{
  "successTitle": "Vérifiez votre e-mail",
  "successMessage": "Nous avons envoyé un lien de vérification à",
  "instructions": "Cliquez sur le lien dans l'e-mail pour vérifier votre compte et finaliser votre inscription.",
  "expiryNote": "Le lien expirera dans 1 heure",
  "resendButton": "Renvoyer l'e-mail de vérification",
  "resendingButton": "Envoi...",
  "backToLogin": "Retour connexion",
  "failureTitle": "Échec de la vérification",
  "errors": {
    "invalidOrExpired": "Lien de vérification invalide ou expiré. Veuillez en demander un nouveau.",
    "genericError": "Une erreur s'est produite. Veuillez réessayer.",
    "noEmail": "Aucune adresse e-mail disponible. Veuillez vous inscrire à nouveau.",
    "resendFailed": "Échec de l'envoi de l'e-mail de vérification. Veuillez réessayer."
  }
}
